import { render, staticRenderFns } from "./CorrelationForm.vue?vue&type=template&id=2ba51d38&scoped=true"
import script from "./CorrelationForm.vue?vue&type=script&lang=ts"
export * from "./CorrelationForm.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationForm.vue?vue&type=style&index=0&id=2ba51d38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba51d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba51d38')) {
      api.createRecord('2ba51d38', component.options)
    } else {
      api.reload('2ba51d38', component.options)
    }
    module.hot.accept("./CorrelationForm.vue?vue&type=template&id=2ba51d38&scoped=true", function () {
      api.rerender('2ba51d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CorrelationForm.vue"
export default component.exports